import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'bosch-ui-table-cell',
    templateUrl: './bosch-ui-table-cell.component.html',
    styleUrls: ['./bosch-ui-table-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BoschUiTableCellComponent {}
